import React from "react";

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

const IconReportBug: React.FC<IconProps> = ({
  size = 20,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 19 24"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}>
    <path
      d="M1.84 23H16.56C17.0478 22.9995 17.5155 22.8176 17.8604 22.4942C18.2054 22.1708 18.3994 21.7323 18.4 21.275V6.31034C18.4 6.22591 18.3801 6.14253 18.3419 6.06611C18.3036 5.98969 18.2479 5.92211 18.1786 5.86816L10.8419 0.150937C10.7263 0.0571438 10.5795 0.00380673 10.4267 0H1.84C1.35218 0.000532626 0.884495 0.182444 0.539551 0.505829C0.194608 0.829214 0.000568134 1.26767 0 1.725V21.275C0.000568134 21.7323 0.194608 22.1708 0.539551 22.4942C0.884495 22.8176 1.35218 22.9995 1.84 23ZM16.0926 5.75H11.6337C11.4811 5.75411 11.333 5.7014 11.2217 5.6034C11.1105 5.5054 11.0451 5.37008 11.04 5.22704V1.80263L16.0926 5.75ZM1.22667 1.725C1.22683 1.57255 1.2915 1.42638 1.40649 1.31858C1.52147 1.21078 1.67738 1.15015 1.84 1.15H9.81333V5.22704C9.81868 5.67507 10.0134 6.10283 10.3547 6.41646C10.696 6.73009 11.1561 6.90399 11.634 6.9H17.1733V21.275C17.1732 21.4275 17.1085 21.5736 16.9935 21.6814C16.8785 21.7892 16.7226 21.8498 16.56 21.85H1.84C1.67738 21.8498 1.52147 21.7892 1.40649 21.6814C1.2915 21.5736 1.22683 21.4275 1.22667 21.275V1.725Z"
      fill="currentColor"
    />
    <path
      d="M9.19922 8.2998C12.2368 8.2998 14.6992 10.7622 14.6992 13.7998C14.6992 16.8374 12.2368 19.2998 9.19922 19.2998C6.16165 19.2998 3.69922 16.8374 3.69922 13.7998C3.69922 10.7622 6.16165 8.2998 9.19922 8.2998Z"
      fill="none"
      stroke="#EB3428"
      strokeWidth="1"
    />
    <path
      d="M9.19747 14.9498C8.98924 14.9498 8.78909 14.8692 8.63895 14.7249C8.4888 14.5806 8.40032 14.3839 8.39202 14.1758L8.28578 11.4931C8.28152 11.3846 8.29919 11.2764 8.33775 11.175C8.3763 11.0736 8.43494 10.9809 8.51016 10.9027C8.58537 10.8245 8.6756 10.7622 8.77545 10.7197C8.8753 10.6772 8.9827 10.6553 9.09123 10.6553H9.30371C9.41223 10.6553 9.51964 10.6772 9.61948 10.7197C9.71933 10.7622 9.80957 10.8245 9.88478 10.9027C9.95999 10.9809 10.0186 11.0736 10.0572 11.175C10.0957 11.2764 10.1134 11.3846 10.1092 11.4931L10.0029 14.1758C9.99462 14.3839 9.90613 14.5806 9.75599 14.7249C9.60585 14.8692 9.4057 14.9498 9.19747 14.9498Z"
      fill="#EB3428"
    />
    <path
      d="M10.0041 16.1407C10.0041 15.6962 9.64377 15.3359 9.19931 15.3359C8.75484 15.3359 8.39453 15.6962 8.39453 16.1407C8.39453 16.5852 8.75484 16.9455 9.19931 16.9455C9.64377 16.9455 10.0041 16.5852 10.0041 16.1407Z"
      fill="#EB3428"
    />
  </svg>
);

export default IconReportBug;
